import { Outlet, ScrollRestoration } from 'react-router';
import { Header } from '../components/Header/Header';
import { useActiveLocation } from '../hooks/useActiveLocation';
import {
  useFetchAccountPermissions,
  useFetchLocationPermissions
} from '../hooks/usePermissions';

export const RootLayout = () => {
  // Both permission sets are loaded once here rather than per page, so the
  // navigation and every page below it answer from the same state. The location
  // set follows the active location, which is the URL's :locationId on every
  // location-scoped route.
  const { activeLocationId } = useActiveLocation();
  useFetchAccountPermissions();
  useFetchLocationPermissions(activeLocationId);

  return (
    <>
      {/*
          ScrollRestoration component automatically restores the scroll
          position when navigating between pages
      */}
      <ScrollRestoration />

      <Header />
      <Outlet />
    </>
  );
};
